import { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard } from 'swiper/modules';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import i18next from 'i18next';
import 'swiper/css';

import { malaysiaParliamentaryElectionHistory } from '../../config/historicge';
import PageMeta from '../PageMeta';
import YearSlide from './YearSlide';
import SeatTrendStrip from './SeatTrendStrip';
import CoalitionLineage from './CoalitionLineage';
import './HistoricalElection.css';

const history = malaysiaParliamentaryElectionHistory;

const HistoricalElection = () => {
  const [activeIndex, setActiveIndex] = useState(history.length - 1);
  const [showLineage, setShowLineage] = useState(true);
  const swiperRef = useRef(null);

  const goTo = (idx) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(idx);
    }
    setActiveIndex(idx);
  };

  return (
    <div className="historical-election">
      <PageMeta prefix="历届国会选举" />
      <header className="historical-election__title">
        <h1>{i18next.t('历史上的国席成绩')}</h1>
        <p className="historical-election__subtitle">
          1955 — 2022 · {i18next.t('马来西亚国会议席演变')}
        </p>
      </header>

      <nav className="historical-election__rail" aria-label="Election years">
        {history.map((e, idx) => (
          <button
            key={e.year}
            type="button"
            className={`year-pill ${idx === activeIndex ? 'is-active' : ''}`}
            onClick={() => goTo(idx)}
          >
            {e.year}
          </button>
        ))}
      </nav>

      <div className="historical-election__swiper-wrap">
        <button
          type="button"
          className="historical-election__nav historical-election__nav--prev"
          onClick={() => goTo(activeIndex - 1)}
          disabled={activeIndex === 0}
          aria-label={i18next.t('上一届')}
        >
          <IoChevronBack />
        </button>
        <Swiper
          modules={[Keyboard]}
          keyboard={{ enabled: true }}
          spaceBetween={24}
          slidesPerView={1}
          initialSlide={history.length - 1}
          onSwiper={(s) => { swiperRef.current = s; }}
          onSlideChange={(s) => setActiveIndex(s.activeIndex)}
          className="historical-election__swiper"
        >
          {history.map((election, idx) => (
            <SwiperSlide key={election.year}>
              {Math.abs(idx - activeIndex) <= 1 ? (
                <YearSlide election={election} />
              ) : (
                <div className="year-slide year-slide--placeholder">
                  <h2>{election.year}</h2>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
        <button
          type="button"
          className="historical-election__nav historical-election__nav--next"
          onClick={() => goTo(activeIndex + 1)}
          disabled={activeIndex === history.length - 1}
          aria-label={i18next.t('下一届')}
        >
          <IoChevronForward />
        </button>
      </div>

      <div className="historical-election__extra">
        <button
          type="button"
          className="lineage-toggle"
          onClick={() => setShowLineage((v) => !v)}
        >
          {showLineage ? i18next.t('收起政党联盟流变') : i18next.t('查看政党联盟流变')}
        </button>
        {showLineage && <CoalitionLineage history={history} />}
      </div>

      {/*<div className="historical-election__trend">
        <h4>{i18next.t('历年议席走势')}</h4>
        <SeatTrendStrip
          history={history}
          activeIndex={activeIndex}
          onPickYear={goTo}
        />
      </div>*/}
    </div>
  );
};

export default HistoricalElection;
